import { isClient, withoutFragment } from "@solvari/utils";

import { createArgusEvent } from "@/client/createArgusEvent";
import { createGtmEvent } from "@/client/gtm/gtm";

function addCurrentPageEvent() {
  return createArgusEvent("page_view", {
    pageType: "page",
    url: withoutFragment(window.location.href),
  });
}

function addReferrerPageEvent() {
  if (!document.referrer) {
    return;
  }
  return createArgusEvent("page_view", {
    pageType: "referrer",
    url: document.referrer,
  });
}

function addPageViewGtmEvent(referrer?: string) {
  if (!isClient()) {
    return;
  }
  return createGtmEvent("page_view", {
    pageLocation: withoutFragment(window.location.href),
    pageReferrer: withoutFragment(referrer ?? document.referrer),
  });
}

export { addCurrentPageEvent, addPageViewGtmEvent, addReferrerPageEvent };
